import { Record } from "immutable";

import Dimensions from "../../../../constants/styles/dimensions";
import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";
import { MindmapViewOptionsRecord } from "../../model/appState/MindmapViewOptionsRecord";
import { OutlineViewOptionsRecord } from "../../model/appState/OutlineViewOptionsRecord";
import { RelationshipViewOptionsRecord } from "../../model/appState/RelationshipViewOptionsRecord";
import { SpreadsheetViewOptionsRecord } from "../../model/appState/SpreadsheetViewOptionsRecord";
import { SubwayViewOptionsRecord } from "../../model/appState/SubwayViewOptionsRecord";
import { TimelineViewOptionsRecord } from "../../model/appState/TimelineViewOptionsRecord";

export const ViewDisplayRecord = Record({
  viewId: null,
  viewType: null,
  isActive: false,
  timelineOptions: TimelineViewOptionsRecord(),
  relationshipOptions: RelationshipViewOptionsRecord(),
  outlineOptions: OutlineViewOptionsRecord(),
  spreadsheetOptions: SpreadsheetViewOptionsRecord(),
  mindmapOptions: MindmapViewOptionsRecord(),
  subwayOptions: SubwayViewOptionsRecord(),
  size: SizeRecord(),
  storedSize: SizeRecord(),
  minSize: SizeRecord({
    width: Dimensions.MIN_WORKVIEW_SIZE,
    height: Dimensions.MIN_WORKVIEW_HEIGHT
  })
});

const data = {
  collections: {
    rows: "RelationshipItemDisplayRecord",
    cols: "RelationshipColumnGroupDisplayRecord"
  },
  objects: {
    timelineOptions: "TimelineViewOptionsRecord",
    relationshipOptions: "RelationshipViewOptionsRecord",
    outlineOptions: "OutlineViewOptionsRecord",
    spreadsheetOptions: "SpreadsheetViewOptionsRecord",
    mindmapOptions: "MindmapViewOptionsRecord",
    subwayOptions: "SubwayViewOptionsRecord"
  }
};
createFromJS.registerCallback("ViewDisplayRecord", createFromJS.createNestedCallback(ViewDisplayRecord, data));
